// extracted by mini-css-extract-plugin
export var bounce = "style-module--bounce--55ec8";
export var dot = "style-module--dot--31c68";
export var logo = "style-module--logo--2c283";